<template>
    <DatePicker 
            v-model="date" 
            :enableTimePicker="false" 
            range 
            multi-calendars
            :dark="$store.state.darkMode"
            auto-apply
            :timezone="{ 
                convertModel: false, 
                timezone: 'UTC' 
            }"
            :start-time="{
                hours:0,
                minutes:0,
                seconds:0
            }"
            :end-time="{
                hours:23,
                minutes:59,
                seconds:0
            }"
            utc="preserve"
            :min-date="minDate"
            hide-input-icon
            @update:model-value="handleDateUpdate"
              />
</template>

<script>
//import { ref } from 'vue';
import DatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';


export default {
    name: 'DatePickerComponent',
    emits: ['date-selected'],
    props: ["dates", "minDate"],
    components: {
        DatePicker
    },
    data() {
        return {
            date: this.dates,
            tz: 'UTC'
        }  
    },
    methods: {
        handleDateUpdate(incoming) {
            console.log("incoming",incoming);
            const actualDates = [
                new Date(incoming[0]),
                new Date(incoming[1])
            ];
            actualDates[0].setTime(actualDates[0].getTime() + 60 * 1000);
            actualDates[1].setUTCHours(23, 59, 59);
            this.date = actualDates;
            this.$emit('date-selected',actualDates);
        }
    },
    mounted() {
        if (!this.dates || !this.dates[0] || this.dates[0] == 'Invalid Date') {
            const currentDate = new Date();
            //currentDate.setTime(currentDate.getTime()-(currentDate.getTimezoneOffset()*60000))
            const startDate = new Date(currentDate.getTime());
            startDate.setDate(startDate.getDate() - 7)
            startDate.setUTCHours(0,0,0,0);
            const endDate = currentDate;
            endDate.setUTCHours(23,59,59,0);
            //endDate.setTime(endDate.getTime()+(endDate.getTimezoneOffset()*60000))
            this.date = [startDate, endDate];
            this.$emit('date-selected',this.date);

        }

    }
};
</script>
<style>
.dp__input {
    font-size:0.7rem;
}
</style>